import { render, staticRenderFns } from "./DialogDetailGeneralEmail.vue?vue&type=template&id=18a195c9&"
import script from "./DialogDetailGeneralEmail.vue?vue&type=script&lang=js&"
export * from "./DialogDetailGeneralEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports